export default {
  notAllowedToAddTips: lang.templateByUuid("UID:P_UDHWN_17DD50DE050005AF","您的客户私有用户达到上限，新增操作已被禁止！") /* "您的客户私有用户达到上限，新增操作已被禁止！" */
};
